<template>
      <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Add Drug</p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>
            <section class="modal-card-body">
                <!--                  content-->
                <b-table
                        :data="mstDrugPARADat"
                        :bordered=false
                        :striped=false
                        :checked-rows.sync="checkedRows"
                        checkable
                        narrowed
                        :hoverable=false
                        :focusable=false
                        mobile-cards>

                    <b-table-column   label="Drug Name"    v-slot="props">
                        <span :class="isIDSelected(props.row.id) ? '  title has-text-weight-bold has-text-primary ' : '' "   >
                            {{ props.row.name }}
                        </span>
                    </b-table-column>
                </b-table>

            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"  @click="closeBtn">Cancel</b-button>
                <b-button type="is-success" @click="save">Save</b-button>
            </footer>
        </div>
    </div>
</template>


<script>
   import {mapState} from "vuex";

    export default {
        name: "SelectDrugParasite",
        props:{
            isShowing : Boolean,
            drugExisting : Array
        },
        computed: {
            ...mapState({
                // mstDrugDat: state => state.bact.mstDrugDat,
                mstDrugPARADat: state => state.parasite.mstDrugPARADat,
            })
        },
        methods:{    
            closeBtn(){
               this.$emit('closeSelectDrug')
            },
            save(){
                this.$emit('closeSelectDrugWithData',this.checkedRows)
            },
            isIDSelected(_id){
                const tmp =  this.checkedRows.find(dat=>{
                    return dat.id === _id
                })
                return tmp ? true : false
            }
        },
        data(){
            return{
                checkedRows : []
            }
        },
   
    }
</script>